"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportType = void 0;
var ExportType;
(function (ExportType) {
    ExportType["WORKS"] = "works";
    ExportType["MATCH_HISTORY"] = "match-history";
    ExportType["MATCH_RECORDINGS"] = "match-recordings";
    ExportType["OVERCLAIMS"] = "overclaims";
    ExportType["SONGWRITER_WORKS"] = "songwriter-works";
    ExportType["REGISTRATION_HISTORY"] = "registration-history";
})(ExportType || (exports.ExportType = ExportType = {}));
